<template>
  <v-app>
    <!-- <img width="100%" height="100%" style="position:fixed" :src="require('@/assets/white_bg.png')" /> -->
    <toolbar-navbar
      ref="toolbar"
      v-if="$store.state.token"
      :miniVariant="miniVariant"
      @mouseOverMini="mouseOverMini"
      @mouseOutMini="mouseOutMini"
      :menuItems="$store.state.menu"
      @logout="logout"
      @settings="settings"
      @backToProject="
        $store.state.client_status  
          ? $store.state.sub_company_menu.length
            ? backToSubCompany()
            : backToCompany()
          : backToProject()
      "
      @backToCompany="backToCompany"
      @backToSubCompany="backToSubCompany"
      :profilePic="profilePic"
    ></toolbar-navbar>
    <v-content @scroll="handleScroll">
      <router-view />
    </v-content>

    <v-fab-transition>
      <v-btn
        ref="button"
        fixed
        v-if="offsetTop > 100"
        dark
        right
        bottom
        fab
        small
        color="grey darken-3"
        @click="$vuetify.goTo(0)"
      >
        <v-icon large>keyboard_arrow_up</v-icon>
      </v-btn>
    </v-fab-transition>
    <page-loading v-if="$store.state.loading" />
    <page-unauthorized v-if="$store.state.unauthorized" />
    <info-bar></info-bar>
    <settings ref="setting"></settings>
    <v-footer class="grey lighten-5 px-4">
      <v-spacer></v-spacer>
      <div>
        <b>{{ appVersion }}</b>
      </div>
    </v-footer>
  </v-app>
</template>

<script>
import ToolbarNavbar from "./components/ToolbarNavigationbar";
import Settings from "./components/Settings";
import PageLoading from "./components/PageLoading";
import PageUnauthorized from "./components/PageUnauthorized";

export default {
  components: {
    ToolbarNavbar,
    PageLoading,
    PageUnauthorized,
    Settings,
  },
  data() {
    return {
      appVersion: null,
      miniVariant: true,
      offsetTop: 0,
    };
  },
  watch: {
    async $route(to, from) {
      await this.pageAaccess();
    },
  },
  mounted() {},
  computed: {
    profilePic() {
      let avatarStyle = "Transparent";
      let topType = "ShortHairShortCurly";
      let accessoriesType = "Prescription02";
      let hairColor = "Auburn";
      let facialHairType = "Blank";
      let clotheType = "Hoodie";
      let clotheColor = "Gray01";
      let eyeType = "Squint";
      let eyebrowType = "DefaultNatural";
      let mouthType = "Smile";
      let skinColor = "Light";

      let clotheColorArray = [
        "Black",
        "Blue01",
        "Blue02",
        "Blue03",
        "Gray01",
        "Gray02",
        "Heather",
        "PastelBlue",
        "PastelGreen",
        "PastelOrange",
        "PastelRed",
        "PastelYellow",
        "Pink",
        "Red",
        "White",
      ];

      let clotheColorIndex = Math.floor(
        Math.random() * clotheColorArray.length
      );

      clotheColor = clotheColorArray[clotheColorIndex];

      if (this.$store.state.employee.gender === "female") {
        topType = "LongHairNotTooLong";
      }

      return `https://avataaars.io/?avatarStyle=${avatarStyle}&topType=${topType}&accessoriesType=${accessoriesType}&hairColor=${hairColor}&facialHairType=${facialHairType}&clotheType=${clotheType}&clotheColor=${clotheColor}&eyeType=${eyeType}&eyebrowType=${eyebrowType}&mouthType=${mouthType}&skinColor=${skinColor}`;
    },
  },
  methods: {
    handleScroll() {
      this.offsetTop = window.pageYOffset || document.documentElement.scrollTop;
    },
    mouseOverMini: function() {
      this.miniVariant = false;
    },
    mouseOutMini: function() {
      this.miniVariant = true;
    },
    async logout() {
      await this.$router.push({
        path: "/",
      });
      await this.$store.dispatch("clearStore");
    },
    async pageAaccess() {
      let pageAccess = false;

      let data = [];

      if (this.$route.name === "Page Not Found") {
        this.$store.dispatch("clearStore");
        pageAccess = true;
      } else if (this.$store.state.menu.length) {
        pageAccess = this.$store.state.menu.some((item) => {
          data = item.modules;
          return item.link === this.$route.path;
        });
      }

      if (pageAccess) {
        this.$store.dispatch("dispatchModule", data);
      } else {
        this.$store.dispatch("clearStore");
        this.$store.dispatch("dispatchUnauthorized", true);
      }

      if (process.env.VUE_APP_VERSION) {
        localStorage.appVersion = process.env.VUE_APP_VERSION;
        this.appVersion = localStorage.appVersion;
      }
    },
    backToProject() {
      if (this.$store.state.main_menu.length) {
        let page = this.$isEmpty(this.$store.state.company)
          ? this.$store.state.main_menu[0]
          : this.$store.state.main_menu.find((item) => {
              return item.link === "/companies";
            });

        if (page) {
          if (this.$route.path !== page.link) {
            this.$store.dispatch("dispatchMenu", this.$store.state.main_menu);
            this.$router.push({
              path: page.link,
            });

            this.$store.dispatch("dispatchCompany", {});
            this.$store.dispatch("dispatchSubCompany", {});
          }
        }
      }
    },
    backToCompany() {
      if (this.$store.state.company_menu.length) {
        let page = this.$isEmpty(this.$store.state.subcompany)
          ? this.$store.state.company_menu[0]
          : this.$store.state.company_menu.find((item) => {
              return item.link === "/c/sub-companies";
            });

        if (page) {
          if (this.$route.path !== page.link) {
            this.$store.dispatch(
              "dispatchMenu",
              this.$store.state.company_menu
            );
            this.$router.push({
              path: page.link,
            });
            this.$store.dispatch("dispatchSubCompany", {});
          }
        }
      }
    },
    backToSubCompany() {
      if (this.$store.state.menu.length) {
        let page = this.$store.state.menu[0];

        if (page) {
          if (this.$route.path !== page.link) {
            this.$router.push({
              path: page.link,
            });
          }
        }
      }
    },
    async settings() {
      this.$refs.setting.openDialog();
    },
  },

  created: function() {
    window.addEventListener("scroll", this.handleScroll);
  },
  destroyed: function() {
    window.removeEventListener("scroll", this.handleScroll);
  },
};
</script>
